import { TFunction } from 'i18next'
import MssqlUserRestService from '../rest/MssqlUserRestService'

class MssqlUserService {
  static async getUsers() {
    return MssqlUserRestService.getUsers()
  }

  static async createUser(user: any, setUsers: React.Dispatch<any>, t: TFunction) {
    try {
      await MssqlUserRestService.createUser(user)
      const updatedUsers = await MssqlUserRestService.getUsers()
      setUsers(updatedUsers)
      return t('mssqlAdapter.createUserSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async deleteUser(id: number, setUsers: React.Dispatch<any>, t: TFunction) {
    try {
      await MssqlUserRestService.deleteUser(id)
      const updatedUsers = await MssqlUserRestService.getUsers()
      setUsers(updatedUsers)
      return t('mssqlAdapter.deleteteUserSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default MssqlUserService
